import { useState, useEffect } from 'react';
import { AdminShell } from '@/components/AdminShell';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import api from '@/lib/api';

export default function AdminAuditLog() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get('/admin/audit-log?limit=100').then(res => {
      setLogs(res.data.logs || []);
      setTotal(res.data.total || 0);
    }).catch(console.error);
  }, []);

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';

  const actionColors = {
    create: 'border-[rgba(122,158,126,0.4)] text-[hsl(var(--sage))]',
    update: 'border-[rgba(201,168,76,0.3)] text-[hsl(var(--gold))]',
    delete: 'border-[rgba(185,105,122,0.3)] text-[hsl(var(--rose))]',
  };

  return (
    <AdminShell title="Audit Log">
      <p className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] mb-6">
        {total} recorded action{total !== 1 ? 's' : ''}
      </p>

      <div className="rounded-xl border border-[rgba(201,168,76,0.12)] overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-[rgba(201,168,76,0.08)] hover:bg-transparent">
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Admin</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Action</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Entity</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Details</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="text-center font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] py-8">No audit entries yet.</TableCell></TableRow>
            ) : logs.map(log => (
              <TableRow key={log._id} className="border-b border-[rgba(201,168,76,0.06)] hover:bg-[rgba(27,77,68,0.08)]">
                <TableCell className="font-['Inter'] text-sm text-[hsl(var(--foreground))]">{log.admin_email}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={`font-['Inter'] text-[9px] uppercase tracking-[0.12em] ${actionColors[log.action] || ''}`}>
                    {log.action}
                  </Badge>
                </TableCell>
                <TableCell className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))]">{log.entity_type}</TableCell>
                <TableCell className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] max-w-xs truncate">{log.details}</TableCell>
                <TableCell className="font-['Inter'] text-xs text-[hsl(var(--silver))]">{formatDate(log.timestamp)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </AdminShell>
  );
}
